document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("charge-calculator-widget");
  if (!container) return;

  function calculateChargeTemp() {
    let base = 250;

    // Roast Weight Δ relative to 1000g max, 500g nominal
    let defaultWeight = 500;
    let maxCharge = 1000;
    let roastWeight = parseFloat(document.getElementById("roast_weight").value) || 0;
    let roastPercent = (roastWeight / maxCharge) * 100;
    let defaultPercent = (defaultWeight / maxCharge) * 100; // 50%
    let deltaBatchPercent = roastPercent - defaultPercent;
    let weightAdj = 1.2 * deltaBatchPercent;

    // Density Δ
    let density = document.getElementById("density").value;
    let densityAdj = (density === "low") ? -10 : (density === "high") ? 10 : (density === "veryhigh") ? 15 : 0;

    // Process Δ
    let process = document.getElementById("process").value;
    let processAdj = (process === "honey") ? -8 : (process === "natural") ? -15 : 0;

    // Moisture Δ
    let moisture = parseFloat(document.getElementById("moisture").value);
    let moistureAdj = (!isNaN(moisture)) ? (moisture - 10.5) * 4 : 0;

    // Strategy Δ
    let strategy = document.getElementById("strategy").value;
    let strategyAdj = (strategy === "fast") ? 12 : (strategy === "slow") ? -10 : 0;

    // Ambient Δ
    let ambient = parseFloat(document.getElementById("ambient").value);
    let ambientAdj = (!isNaN(ambient)) ? (ambient - 20) * 0.5 : 0;

    // Final Charge Temp
    let chargeTemp = base + weightAdj + densityAdj + processAdj + moistureAdj + strategyAdj + ambientAdj;
    document.getElementById("charge_temp").innerText = chargeTemp.toFixed(1);
  }

  // Catch-all listener for inputs/selects
  container.querySelectorAll(".calc-input").forEach(el => {
    el.addEventListener("input", calculateChargeTemp);
    el.addEventListener("change", calculateChargeTemp);
  });
});